/**
 * Asynchronously loads the component
 */

import { lazyLoad } from '../../../utils/loadable';

export const RSVPPage = lazyLoad(
    () => import('./index'),
    (module) => module.RSVPPage,
);
